<template>
  <div class="home">
    Bắt đầu
    <hr />
    <a-button type="primary">Primary</a-button>
    <a-button>Default</a-button>
  </div>
</template>

<script>
export default {
  name: "Home",
};
</script>
